import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledPageContainer = styled.div`
  padding: 20px 30px;
`

const StyledLayoutContainer = styled.div`
  min-width: 730px;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  margin: 0 auto;
`

const PageContainer = ({ children, className }) => {
  return (
    <StyledPageContainer className={className}>
      <StyledLayoutContainer>{children}</StyledLayoutContainer>
    </StyledPageContainer>
  )
}

PageContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

export default PageContainer
